<div class="filters">
  <mat-form-field>
    <mat-label translate="users_roles/users_in_role/search"></mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input autocomplete="off" type="text" [formControl]="searchCtrl" matInput />
    <mat-icon role="button" *ngIf="searchCtrl?.value" (click)="clearSearch()" matSuffix>close</mat-icon>
  </mat-form-field>
</div>

<div class="table-wrapper">
  <cdk-virtual-scroll-viewport tvsItemSize="48" [style.height.px]="maxHeight">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="email"
      matSortDirection="asc"
      (matSortChange)="sortData($event)">
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            [disabled]="
              readonly || (!element['rolesSet'].has(roleId) && (element.roles || []).length >= MAX_ROLES_TO_ATTACH)
            "
            [checked]="selectedUserSet.has(element.id)"
            (change)="selectedUsersChange($event, element.id)"></mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="admin/users/email"></span>
        </th>
        <td mat-cell *matCellDef="let element" (click)="redirectToUserEdit(element)">
          <span>{{ element.email }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="common/name"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.name }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="nRoles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="common/number_of_roles"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ (element.roles || []).length }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.disabled]="readonly"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <span translate="no-results"></span>
        </td>
      </tr>
    </table>
  </cdk-virtual-scroll-viewport>
</div>
